/**
 * Front end javascript initialization routines
 *
 * @package
 */

/**
 * Internal dependencies
 */
import map from './map';
import places from './places';

/**
 * Initialisation routine
 */
const init = () => {
	// Initialize the map and places modules
	map();
	places();
};

export default init;
